var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconEnvelopeSimpleOpen = function SvgIconEnvelopeSimpleOpen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M11.445 2.168a1 1 0 0 1 1.11 0l9 6A1 1 0 0 1 22 9v9.75a1.75 1.75 0 0 1-1.75 1.75H3.75A1.75 1.75 0 0 1 2 18.75V9a1 1 0 0 1 .445-.832zM4 10.942l5.779 4.122a1 1 0 0 0 .58.186h3.282a1 1 0 0 0 .58-.186L20 10.942V18.5H4zm15.239-1.914L12 4.202 4.761 9.028l5.919 4.222h2.64z",
    clipRule: "evenodd"
  })));
};
export default SvgIconEnvelopeSimpleOpen;